(function () {
  var SECTION_SELECTOR = '.oddit-cart-drawer';

  function initSection(section) {
    var closeBtn = section.querySelector('.oddit-cart-drawer__close');
    var overlay = section.querySelector('.oddit-cart-drawer__overlay');
    var noteToggle = section.querySelector('[data-order-note-toggle]');
    var noteField = section.querySelector('[data-order-note-field]');
    var note = section.querySelector('[data-order-note]');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(section);
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        close(section);
      });
    }

    if (noteToggle && noteField) {
      noteToggle.addEventListener('click', function () {
        var isHidden = noteField.hasAttribute('hidden');
        if (isHidden) {
          noteField.removeAttribute('hidden');
          if (note) note.focus();
        } else {
          noteField.setAttribute('hidden', '');
        }
        noteToggle.setAttribute('aria-expanded', String(isHidden));
      });
    }

    // The textarea sits outside the cart form, so nothing would ever submit it.
    // change fires on blur, which is one request per edit rather than per keystroke.
    if (note) {
      note.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Cart note update failed: ' + r.status);
          })
          .catch(function (err) { console.error(err); });
      });
    }

    // An open note stays open across a re-render.
    if (noteField && note && note.value) {
      noteField.removeAttribute('hidden');
      if (noteToggle) noteToggle.setAttribute('aria-expanded', 'true');
    }

    // Checkout is a real form submit, so the spinner just has to survive until the
    // navigation. Not disabled: a disabled submitter drops its name=checkout value.
    var checkoutForm = section.querySelector('.oddit-cart-drawer__checkout-wrap form');
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', function (e) {
        var btn = checkoutForm.querySelector('.oddit-cart-drawer__checkout-btn');
        if (!btn) return;
        if (btn.classList.contains('is-loading')) {
          e.preventDefault();
          return;
        }
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
      });
    }

    section.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        close(section);
      }
    });
  }

  // Delegated on document, not on the drawer: cart buttons live all over the theme
  // (product page, sticky bar, editorial sections) and the drawer's own markup is
  // replaced on every refresh, which would drop a section-level listener.
  //
  // One in-flight cart write at a time: every mutation re-renders the drawer, so a
  // second click would act on markup that is about to be replaced.
  var cartBusy = false;

  function withBusy(btn, run) {
    if (cartBusy) return;
    cartBusy = true;
    btn.style.minWidth = btn.getBoundingClientRect().width + 'px';
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    run()
      .catch(function (err) { console.error(err); })
      .finally(function () {
        cartBusy = false;
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.style.minWidth = '';
      });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('product-form form')) return;

      var btn = form.querySelector('.product-card__quick-add-button');
      if (!btn) return;

      var idInput = form.querySelector('input[name="id"]');
      var variantId = idInput ? Number(idInput.value) : 0;
      if (!variantId) return;

      var qtyInput = form.querySelector('input[name="quantity"]');
      var quantity = qtyInput ? Number(qtyInput.value) || 1 : 1;

      e.preventDefault();
      e.stopPropagation();

      withBusy(btn, function () {
        return addToCart(variantId, quantity).then(openDrawer);
      });
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('quick-buy-modal product-form form')) return;

      var btn = e.submitter || form.querySelector('button[type="submit"]');
      if (!btn) return;

      if (btn.classList.contains('is-loading')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      if (!form.checkValidity()) return;

      if (!btn.querySelector('[data-button-label]')) {
        var label = document.createElement('span');
        label.setAttribute('data-button-label', '');
        while (btn.firstChild) label.appendChild(btn.firstChild);
        btn.appendChild(label);
      }

      btn.style.minWidth = btn.getBoundingClientRect().width + 'px';
      btn.classList.add('is-loading');
    },
    true
  );

  function clearQuickBuyLoading() {
    document.querySelectorAll('quick-buy-modal button.is-loading').forEach(function (btn) {
      btn.classList.remove('is-loading');
      btn.style.minWidth = '';
    });
  }

  document.addEventListener('cart:error', clearQuickBuyLoading);

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add-to-cart]');
    if (add) {
      var variantId = Number(add.getAttribute('data-variant-id'));
      if (!variantId) return;
      var addQuantity = Math.max(1, Number(add.getAttribute('data-quantity')) || 1);
      withBusy(add, function () {
        return addToCart(variantId, addQuantity).then(openDrawer);
      });
      return;
    }

    var step = e.target.closest('[data-quantity-change]');
    if (step) {
      var value = step.closest('[data-line-item]').querySelector('[data-quantity-value]');
      var next = parseInt(value.textContent, 10) + Number(step.getAttribute('data-quantity-change'));
      withBusy(step, function () {
        return changeLine(step.getAttribute('data-line-item-key'), Math.max(0, next));
      });
      return;
    }

    var remove = e.target.closest('[data-remove-item]');
    if (remove) {
      withBusy(remove, function () {
        return changeLine(remove.getAttribute('data-line-item-key'), 0);
      });
    }
  });

  function open(section) {
    section.style.display = '';
    document.body.style.overflow = 'hidden';
    // The section ships with inline display:none. Adding is-open in the same
    // frame gives the browser no painted closed state to transition from, so
    // the very first open would jump instead of slide.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        section.classList.add('is-open');
        var panel = section.querySelector('.oddit-cart-drawer__panel');
        if (panel) {
          var firstFocusable = panel.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          if (firstFocusable) firstFocusable.focus({ preventScroll: true });
        }
      });
    });
  }

  function close(section) {
    section.classList.remove('is-open');
    document.body.style.overflow = '';
    var panel = section.querySelector('.oddit-cart-drawer__panel');
    if (panel) {
      panel.addEventListener('transitionend', function handler() {
        panel.removeEventListener('transitionend', handler);
      }, { once: true });
    }
  }

  function getDrawer() {
    return document.querySelector(SECTION_SELECTOR);
  }

  // Re-render from the Section Rendering API so line items, subtotal and the
  // shipping bar reflect the server's cart, then let the header badge update.
  function refresh(cart) {
    var drawer = getDrawer();
    if (!drawer) return Promise.resolve();
    // The section's own id, not its type: passing the type renders the section with
    // default settings and no blocks, which drops the empty-state category cards.
    return fetch('?section_id=' + encodeURIComponent(drawer.id))
      .then(function (r) {
        if (!r.ok) throw new Error('Cart drawer render failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(SECTION_SELECTOR);
        if (!fresh) return;
        var wasOpen = drawer.classList.contains('is-open');
        drawer.innerHTML = fresh.innerHTML;
        // is-empty is on the section root, which innerHTML does not replace: without
        // this the drawer keeps whichever empty/filled state the page loaded with.
        drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
        initSection(drawer);
        if (wasOpen) drawer.classList.add('is-open');
        if (cart) syncLegacyHeader(cart);
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: cart } })
        );
      });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    })
      .then(function (r) {
        // Asking for more than is in stock returns 422 but Shopify still adds what's
        // available, so re-render and open the drawer either way.
        if (!r.ok) console.warn('Add to cart failed: ' + r.status);
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        return refresh(cart);
      });
  }

  // Quantity step and remove are the same call: quantity 0 removes the line.
  // The line item key is what /cart/change.js takes as `id`.
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart change failed: ' + r.status);
        return r.json();
      })
      .then(refresh);
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    clearQuickBuyLoading();
    document.querySelectorAll('quick-buy-modal[open]').forEach(function (modal) {
      modal.hide();
    });
    open(drawer);
  }

  // The live theme's header ships <cart-count>/<cart-dot>, which update on theme.js's
  // cart:change. Set them directly instead: cart:change also makes the legacy
  // cart-drawer re-render itself from detail.cart.sections, which our cart doesn't carry.
  function syncLegacyHeader(cart) {
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.innerText = cart.item_count;
    });
    document.querySelectorAll('cart-dot').forEach(function (el) {
      el.classList.toggle('is-visible', cart.item_count > 0);
    });
  }

  // The live theme's <cart-drawer id="cart-drawer"> (overlay-group) opens from the header
  // cart link ([aria-controls="cart-drawer"]) and after a theme product-form add; both
  // paths call its show(). Shadow that method so ours opens instead and theirs never does.
  function hijackLegacyDrawer() {
    var legacy = document.getElementById('cart-drawer');
    if (!legacy || legacy.odditHijacked) return;
    legacy.odditHijacked = true;
    legacy.show = function () {
      openDrawer();
      return Promise.resolve();
    };
  }

  // A theme product-form add doesn't pass through us: re-render ours from the new cart.
  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.baseEvent === 'variant:add') {
      refresh(e.detail.cart)
        .catch(function (err) { console.error(err); })
        .then(openDrawer);
    }
  });

  // Coming back from checkout restores the page from bfcache with the button
  // still mid-spin.
  window.addEventListener('pageshow', function () {
    var btn = document.querySelector('.oddit-cart-drawer__checkout-btn.is-loading');
    if (!btn) return;
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
  });

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  hijackLegacyDrawer();

  document.addEventListener('shopify:section:load', function (e) {
    hijackLegacyDrawer();
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  window.OdditCartDrawer = {
    open: openDrawer,
    close: function () {
      var drawer = getDrawer();
      if (drawer) close(drawer);
    },
    addToCart: addToCart,
    refresh: refresh,
  };
})();